<template>
  <v-card>
    <v-list two-line>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>{{ animal.tipo.valor ? strings[idioma][animal.tipo.valor] : '' }}</v-list-tile-title>
          <v-list-tile-sub-title v-if="animal.tipo.valor === 'bezerro'">{{ strings[idioma].leite_vaca }} : {{ (animal.producao_de_leite.valor !== null && animal.producao_de_leite.valor !== 0 && animal.producao_de_leite.valor.trim() !== '') ? animal.producao_de_leite.valor : calculaPLe(animal.semana_lactacao.valor, idioma) }}</v-list-tile-sub-title>
          <v-list-tile-sub-title v-if="animal.tipo.valor === 'vaca'"> {{ strings[idioma][animal.estado_fisiologico.valor] }}</v-list-tile-sub-title>
          <v-list-tile-sub-title v-if="animal.tipo.valor === 'crescimento_terminacao'">
            <div style="overflow:auto; max-height:50px">
              <p>{{ strings[idioma][animal.raca.valor] }} | {{ strings[idioma][animal.regime.valor] }} | {{ strings[idioma][animal.sexo.valor] }}</p>
            </div>
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile v-if="animal.tipo.valor === 'vaca' && animal.estado_fisiologico.valor !== 'nao_gestante'">
        <v-list-tile-content>
          <v-list-tile-sub-title
            style="overflow:auto; max-height:200px"
            v-html="animal.estado_fisiologico.valor === 'nao_gestante' ? renderEstadoFisiologico(animal, animal.estado_fisiologico, 0, idioma) :
            (animal.estado_fisiologico.valor === 'lactante' ? renderEstadoFisiologico(animal, animal.estado_fisiologico, 1, idioma) :
            (animal.estado_fisiologico.valor === 'gestante' ? renderEstadoFisiologico(animal, animal.estado_fisiologico, 2, idioma) :
            renderEstadoFisiologico(animal, animal.estado_fisiologico, 3, idioma)))"/>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>{{ strings[idioma].peso_corporal_medio }}</v-list-tile-title>
          <v-list-tile-sub-title>{{ animal.peso_corporal_medio.valor + ' kg' }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>{{ strings[idioma].ganho_medio_diario }}</v-list-tile-title>
          <v-list-tile-sub-title>{{ animal.ganho_medio_diario.valor + ' kg' }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-card>
</template>
<script>
import { mapState } from 'vuex'
import { MULTIPARAS, PRIMIPARAS } from '../../utils/types';
export default {
  props: {
    animal: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState('app', ['idioma', 'strings'])
  },
  methods: {
    calculaPLe (valor, idioma) {
        let result = 0.0;
        switch (this.animal.estado_parides) {
          case PRIMIPARAS:
            result = (
              6.431 -
              0.072 * this.parseString(valor, idioma) -
              6.431 * Math.exp(-2.188 * this.parseString(valor, idioma))
            ).toFixed(2);
            console.log({ result })
          break;
          case MULTIPARAS:
            result = (
              7.996 -
              0.101 * this.parseString(valor, idioma) -
              7.996 * Math.exp(-1.447 * this.parseString(valor, idioma))
            ).toFixed(2);
          break;
          default:
            result = (
              8.819 -
              0.069 * this.parseString(valor, idioma) -
              8.819 * Math.exp(-3.211 * this.parseString(valor, idioma))
            ).toFixed(2);
        }
        return idioma === 0 || idioma === 2
          ? String(result).replace(
              new RegExp("[.]", "g"),
              this.strings[idioma].separador_float
            )
          : String(result);
    },
    renderEstadoFisiologico (animal, estado, index, idioma) {
      if (index === 0) {
        return ''
      } else if (index === 1) {
        let text = ''
        text += animal.producao_de_leite.title[idioma] + ' : ' + animal.producao_de_leite.valor + ((idioma === 0) ? ' kg/dia' : 'kg/day')
        text += '<br>' + animal.semana_lactacao.title[idioma] + ' : ' + animal.semana_lactacao.valor + '<br>' + animal.proteina_do_leite.title[idioma] + ' : ' + animal.proteina_do_leite.valor + ' <br>' + animal.gordura_do_leite.title[idioma] + ' : ' + animal.gordura_do_leite.valor + ' <br>' + animal.lactose_do_leite.title[idioma] + ' : ' + animal.lactose_do_leite.valor
        return text
      } else if (index === 2) {
        let text = ''
        text += animal.escore_corporal.title[idioma] + ' : ' + animal.escore_corporal.valor + '<br>' + animal.peso_bezerro_nascimento.title[idioma] + ' : ' + animal.peso_bezerro_nascimento.valor + ' <br>' + animal.dias_gestacao.title[idioma] + ' : ' + animal.dias_gestacao.valor
        return text
      } else {
        let text = ''
        text += animal.producao_de_leite.title[idioma] + ' : ' + animal.producao_de_leite.valor + ((idioma === 0) ? ' kg/dia' : ' kg/day')
        text += '<br>' + animal.semana_lactacao.title[idioma] + ' : ' + animal.semana_lactacao.valor + '<br>' + animal.proteina_do_leite.title[idioma] + ' : ' + animal.proteina_do_leite.valor + ' <br>' + animal.gordura_do_leite.title[idioma] + ' : ' + animal.gordura_do_leite.valor + ' <br>' + animal.lactose_do_leite.title[idioma] + ' : ' + animal.lactose_do_leite.valor
        text += '<br>' + animal.escore_corporal.title[idioma] + ' : ' + animal.escore_corporal.valor + '<br>' + animal.peso_bezerro_nascimento.title[idioma] + ' : ' + animal.peso_bezerro_nascimento.valor + ' <br>' + animal.dias_gestacao.title[idioma] + ' : ' + animal.dias_gestacao.valor
        return text
      }
    },
    parseString (valor, idioma) {
      return this.$parseString(valor, idioma)
    }
  }
}
</script>
